(function () {
  "use strict";

  function money(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (Number(cents || 0) / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  function parseJSONAttribute(root, name, fallback) {
    try {
      return JSON.parse(root.getAttribute(name) || "");
    } catch {
      return fallback;
    }
  }

  function unique(arr) {
    return arr.filter(function (v, i) { return arr.indexOf(v) === i; });
  }

  function createId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    return "kit-" + Date.now() + "-" + Math.random().toString(16).slice(2);
  }

  // Build a normalized [{id, color, size, available}] list from raw Shopify variant objects.
  // options = product.options array, e.g. ["Cor", "Tamanho"].
  // Auto-detects which position is color and which is size by option name.
  function buildVariantsFromShopify(svArr, options) {
    var colorIdx = -1, sizeIdx = -1;
    for (var i = 0; i < options.length; i++) {
      var n = (options[i] || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
      if (colorIdx < 0 && /cor|colo/.test(n)) colorIdx = i;
      if (sizeIdx < 0 && /tam|size/.test(n)) sizeIdx = i;
    }
    // Defaults: first option = color, second = size (standard apparel layout)
    if (colorIdx < 0) colorIdx = 0;
    if (sizeIdx < 0) sizeIdx = options.length > 1 ? 1 : -1;

    return svArr.map(function (sv) {
      return {
        id: sv.id,
        color: colorIdx >= 0 ? (sv["option" + (colorIdx + 1)] || null) : null,
        size: sizeIdx >= 0 ? (sv["option" + (sizeIdx + 1)] || null) : null,
        available: sv.available !== false,
        // null when untracked — isSizeAvailableForSlot treats null as "no limit"
        inventory: (typeof sv.inventory_quantity === "number" && sv.inventory_quantity > 0) ? sv.inventory_quantity : null,
      };
    });
  }

  function getImageForColor(variants, shopifyVariants, color) {
    var kv = variants.find(function (v) { return v.color === color; });
    if (kv) {
      var sv = shopifyVariants.find(function (v) { return v.id === kv.id; });
      if (sv && sv.featured_image && sv.featured_image.src) return sv.featured_image.src;
    }
    for (var i = 0; i < shopifyVariants.length; i++) {
      if (shopifyVariants[i].featured_image && shopifyVariants[i].featured_image.src) {
        return shopifyVariants[i].featured_image.src;
      }
    }
    return null;
  }

  function updateProductGallery(variantId, shopifyVariants, container) {
    var sv = shopifyVariants.find(function (v) { return v.id === variantId; });
    if (!sv) return;
    var ctx = container || document;

    // 1. Trigger native radio input for option1 (color) — Motion theme uses this for gallery sync
    if (sv.option1) {
      var radios = ctx.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        var r = radios[i];
        if (r.value === sv.option1 || r.getAttribute("data-value") === sv.option1) {
          if (!r.checked) {
            r.checked = true;
            r.dispatchEvent(new Event("change", { bubbles: true }));
          }
          break;
        }
      }
    }

    // 2. Update variant select
    var sel = ctx.querySelector('select[name="id"]');
    if (sel && String(sel.value) !== String(variantId)) {
      sel.value = String(variantId);
      sel.dispatchEvent(new Event("change", { bubbles: true }));
      sel.dispatchEvent(new Event("input", { bubbles: true }));
    }

    // 3. Dispatch variant:changed on the product section (Motion theme gallery listener)
    ctx.dispatchEvent(new CustomEvent("variant:changed", {
      bubbles: true,
      detail: { variant: sv },
    }));
  }

  function initBuilder(root) {
    if (!root || root.dataset.kitBuilderInitialized === "true") return;
    root.dataset.kitBuilderInitialized = "true";

    var productSection = root.closest('[data-section-type="product"]');

    function setKitActive(active) {
      if (productSection) {
        if (active) productSection.classList.add("kit-builder-active");
        else productSection.classList.remove("kit-builder-active");
      }
    }

    var config = parseJSONAttribute(root, "data-kit-config", {});

    // ── Main product ────────────────────────────────────────────────────────
    var productOptions = parseJSONAttribute(root, "data-product-options", []);
    var shopifyVariants = parseJSONAttribute(root, "data-product-variants", []);
    // Use config.variants if provided manually; otherwise auto-build from Shopify variants
    var kitVariants = (Array.isArray(config.variants) && config.variants.length)
      ? config.variants
      : buildVariantsFromShopify(shopifyVariants, productOptions);

    // ── QR Code de Saúde map ────────────────────────────────────────────────
    var qrcodeRoot = productSection && productSection.querySelector('[data-qrcode-root]');
    var qrcodeMap = {};
    var hasAnyQr = false;
    if (qrcodeRoot) {
      try { qrcodeMap = JSON.parse(qrcodeRoot.dataset.qrcodeMap || '{}'); } catch (e) {}
      hasAnyQr = Object.keys(qrcodeMap).some(function (k) { return qrcodeMap[k] === true; });
    }

    // ── Gift product(s) ────────────────────────────────────────────────────────
    // Per-tier gift map: { "<qty>": { title, product_handle, allowed_colors, variants, options } }
    var giftProductsByTier = parseJSONAttribute(root, "data-gift-products", {});
    // Legacy single-gift fallback (configs saved before per-tier gifts existed)
    var legacyGiftConfig = config.gift || null;
    var legacyGiftShopifyVariants = parseJSONAttribute(root, "data-gift-product-variants", []);
    var legacyGiftProductOptions = parseJSONAttribute(root, "data-gift-product-options", []);

    // Active gift state — recomputed by setActiveGift() whenever the tier changes
    var giftConfig = null;
    var giftShopifyVariants = [];
    var giftProductOptions = [];
    var giftVariants = [];
    var giftAllColors = [];
    var allowedColors = null;
    var giftColors = [];

    function buildGiftVariants(cfg, shopVariants, options) {
      if (shopVariants && shopVariants.length) {
        return buildVariantsFromShopify(shopVariants, options || []);
      }
      if (cfg && Array.isArray(cfg.variants) && cfg.variants.length) {
        // Legacy: {id, color, size} or {id, title} format
        var legacy = cfg.variants;
        return legacy[0] && legacy[0].color
          ? legacy
          : legacy.map(function (v) { return { id: v.id, color: null, size: v.title || null, available: v.available !== false }; });
      }
      return [];
    }

    // Point the gift vars at the gift configured for the given tier qty
    // (falls back to the legacy single gift when a tier has no dedicated gift).
    function setActiveGift(tierQty) {
      var entry = tierQty != null ? giftProductsByTier[String(tierQty)] : null;
      if (entry) {
        giftConfig = { title: entry.title, product_handle: entry.product_handle, allowed_colors: entry.allowed_colors };
        giftShopifyVariants = entry.variants || [];
        giftProductOptions = entry.options || [];
      } else {
        giftConfig = legacyGiftConfig;
        giftShopifyVariants = legacyGiftShopifyVariants;
        giftProductOptions = legacyGiftProductOptions;
      }
      giftVariants = buildGiftVariants(giftConfig, giftShopifyVariants, giftProductOptions);
      giftAllColors = unique(giftVariants.map(function (v) { return v.color; }).filter(Boolean));
      allowedColors = (giftConfig && Array.isArray(giftConfig.allowed_colors)) ? giftConfig.allowed_colors : null;
      giftColors = allowedColors
        ? giftAllColors.filter(function (c) { return allowedColors.indexOf(c) >= 0; })
        : giftAllColors;
    }

    // Seed with legacy/default so the vars are defined before any tier is chosen
    setActiveGift(null);

    // ── DOM refs ─────────────────────────────────────────────────────────────
    var tiers = Array.isArray(config.tiers) ? config.tiers : [];

    // Per-tier gift map serialized into cart line item properties so the cart/
    // checkout page (kit-draft-checkout.js) can swap/re-add the correct gift
    // when the paid quantity changes after a line is removed — it has no access
    // to product metafields, only to what was stored on the item at add time.
    var kitTierGiftsMap = {};
    tiers.forEach(function (t) {
      if (!t.gift) return;
      var qty = String(t.qty);
      var entry = giftProductsByTier[qty];
      var title, tierGiftVariants, tierAllowedColors;
      if (entry) {
        title = entry.title;
        tierAllowedColors = Array.isArray(entry.allowed_colors) ? entry.allowed_colors : null;
        tierGiftVariants = buildVariantsFromShopify(entry.variants || [], entry.options || []);
      } else if (legacyGiftConfig) {
        title = legacyGiftConfig.title;
        tierAllowedColors = Array.isArray(legacyGiftConfig.allowed_colors) ? legacyGiftConfig.allowed_colors : null;
        tierGiftVariants = buildGiftVariants(legacyGiftConfig, legacyGiftShopifyVariants, legacyGiftProductOptions);
      } else {
        return;
      }
      kitTierGiftsMap[qty] = { title: title, allowed_colors: tierAllowedColors, variants: tierGiftVariants };
    });
    var kitTierGifts = JSON.stringify(kitTierGiftsMap);

    var tiersEl = root.querySelector("[data-kit-tiers]");
    var slotsEl = root.querySelector("[data-kit-slots]");
    var messageEl = root.querySelector("[data-kit-message]");
    var addButton = root.querySelector("[data-kit-add]");

    // Native price elements — saved for restore when kit deactivated
    var nativePriceEl = productSection && productSection.querySelector("[data-product-price]");
    var nativeCompareEl = productSection && productSection.querySelector("[data-compare-price]");
    var nativePriceWrap = productSection && productSection.querySelector("[data-product-price-wrap]");
    var origNativePrice = nativePriceEl ? nativePriceEl.innerHTML : null;
    var origNativeCompare = nativeCompareEl ? nativeCompareEl.innerHTML : null;
    var origWrapVisible = nativePriceWrap ? !nativePriceWrap.classList.contains("hide") : true;

    if (addButton) addButton.hidden = true;

    var allColors = unique(kitVariants.map(function (v) { return v.color; }).filter(Boolean));
    var allSizes = unique(kitVariants.map(function (v) { return v.size; }).filter(Boolean));

    // ── State ────────────────────────────────────────────────────────────────
    var state = {
      tier: null,
      activeSlide: 0,
      slots: [],     // slots[i] = {color, size}
      slotsMeta: [], // slotsMeta[i] = {colorPicked, sizePicked}
      gift: { color: null, size: null, colorPicked: false, sizePicked: false },
    };

    var trackEl = null;

    // ── Cross-slot inventory helpers ──────────────────────────────────────────
    function usedCountInOtherSlots(color, size, currentSlotIndex) {
      var count = 0;
      for (var i = 0; i < state.slots.length; i++) {
        if (i === currentSlotIndex) continue;
        var s = state.slots[i] || {};
        if (s.color === color && s.size === size) count++;
      }
      return count;
    }

    function isSizeAvailableForSlot(color, size, slotIndex) {
      var v = kitVariants.find(function (kv) { return kv.color === color && kv.size === size; });
      if (!v || v.available === false) return false;
      // inventory=null means untracked or Shopify didn't expose the count — don't cross-block
      if (v.inventory === null) return true;
      return usedCountInOtherSlots(color, size, slotIndex) < v.inventory;
    }

    function isColorAvailableForSlot(color, slotIndex) {
      return kitVariants.some(function (v) {
        return v.color === color && isSizeAvailableForSlot(color, v.size, slotIndex);
      });
    }

    function refreshOtherSlides(changedSlotIndex) {
      var n = Number(state.tier && state.tier.qty || 0);
      for (var j = 0; j < n; j++) {
        if (j !== changedSlotIndex) refreshSlide(j);
      }
    }

    // ── Helpers ───────────────────────────────────────────────────────────────
    function totalSlides() {
      if (!state.tier) return 0;
      return Number(state.tier.qty || 0) + (state.tier.gift && giftConfig ? 1 : 0);
    }

    function isGiftSlide(i) {
      return !!(state.tier && state.tier.gift && giftConfig && i === Number(state.tier.qty || 0));
    }

    function isLastSlide(i) {
      return i === totalSlides() - 1;
    }

    function isSlideComplete(i) {
      if (isGiftSlide(i)) {
        var needColor = giftColors.length > 1;
        var giftNeedsSize = unique(giftVariants.map(function (v) { return v.size; }).filter(Boolean)).length > 0;
        if (needColor && giftNeedsSize) return !!(state.gift.colorPicked && state.gift.sizePicked);
        if (needColor) return !!(state.gift.colorPicked);
        if (giftNeedsSize) return !!(state.gift.sizePicked);
        return true; // sem cor e sem tamanho — nada para selecionar, sempre completo
      }
      var meta = state.slotsMeta[i] || {};
      if (allSizes.length === 0) return !!(meta.colorPicked);
      return !!(meta.colorPicked && meta.sizePicked);
    }

    function setMessage(msg, isError) {
      messageEl.textContent = msg || "";
      messageEl.classList.toggle("errors", !!isError);
    }

    function updateNativePrice() {
      if (!nativePriceEl) return;
      if (!state.tier) {
        if (origNativePrice !== null) nativePriceEl.innerHTML = origNativePrice;
        if (nativeCompareEl && origNativeCompare !== null) nativeCompareEl.innerHTML = origNativeCompare;
        if (nativePriceWrap) nativePriceWrap.classList.toggle("hide", !origWrapVisible);
        return;
      }
      var total = Number(state.tier.unit_price || 0) * Number(state.tier.qty || 1);
      nativePriceEl.textContent = money(total);
      var compareTotal = state.tier.discount_per_unit > 0
        ? (Number(state.tier.unit_price || 0) + Number(state.tier.discount_per_unit || 0)) * Number(state.tier.qty || 1)
        : 0;
      if (nativeCompareEl) {
        if (compareTotal > 0) {
          nativeCompareEl.textContent = money(compareTotal);
          if (nativePriceWrap) nativePriceWrap.classList.remove("hide");
        } else {
          if (nativePriceWrap) nativePriceWrap.classList.add("hide");
        }
      }
    }

    function goToSlide(i) {
      state.activeSlide = i;
      if (trackEl) trackEl.style.transform = "translate3d(-" + (i * 100) + "%, 0, 0)";
    }

    function refreshSlide(slideIndex) {
      if (!trackEl) return;
      var existing = trackEl.querySelectorAll(".kit-builder__slide")[slideIndex];
      if (!existing) return;
      var fresh = isGiftSlide(slideIndex) ? buildGiftSlide() : buildPaidSlide(slideIndex);
      existing.parentNode.replaceChild(fresh, existing);
    }

    // ── Slide actions (advance / back buttons) ────────────────────────────────
    function buildSlideActions(slideIndex) {
      var complete = isSlideComplete(slideIndex);
      var last = isLastSlide(slideIndex);
      var actions = document.createElement("div");
      actions.className = "kit-builder__slide-actions";

      var advanceBtn = document.createElement("button");
      advanceBtn.type = "button";
      advanceBtn.className = "kit-builder__advance" + (complete ? "" : " kit-builder__advance--locked");
      advanceBtn.disabled = !complete;
      advanceBtn.textContent = last ? "ADICIONAR AO CARRINHO" : "IR PARA O PRÓXIMO ITEM →";

      advanceBtn.addEventListener("click", last ? submitKit : function () { goToSlide(slideIndex + 1); });
      actions.appendChild(advanceBtn);

      if (slideIndex > 0) {
        var backBtn = document.createElement("button");
        backBtn.type = "button";
        backBtn.className = "kit-builder__back";
        backBtn.textContent = "← Voltar ao item anterior";
        backBtn.addEventListener("click", function () { goToSlide(slideIndex - 1); });
        actions.appendChild(backBtn);
      }

      return actions;
    }

    // ── Color swatch list ─────────────────────────────────────────────────────
    function buildSwatches(colors, activeColor, onClick, isAvailableFn) {
      var wrap = document.createElement("div");
      wrap.className = "kit-builder__swatches";
      colors.forEach(function (color) {
        var available = isAvailableFn ? isAvailableFn(color) : true;
        var slug = color.toLowerCase()
          .normalize("NFD")
          .replace(/[̀-ͯ]/g, "")
          .replace(/[\s_]+/g, "-");
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "kit-builder__swatch kit-builder__swatch--" + slug +
          (color === activeColor ? " is-active" : "") +
          (!available ? " kit-builder__swatch--unavailable" : "");
        btn.title = color;
        btn.disabled = !available;
        btn.setAttribute("aria-label", color + (!available ? " (esgotado)" : ""));
        if (available) btn.addEventListener("click", function () { onClick(color); });
        wrap.appendChild(btn);
      });
      return wrap;
    }

    // ── Option label (e.g. "Cor: Preto") ─────────────────────────────────────
    function buildOptionLabel(labelText, valueText) {
      var p = document.createElement("p");
      p.className = "kit-builder__option-label";
      p.appendChild(document.createTextNode(labelText));
      if (valueText) {
        var s = document.createElement("span");
        s.textContent = " " + valueText;
        p.appendChild(s);
      }
      return p;
    }

    // ── Size button list ──────────────────────────────────────────────────────
    function buildSizeButtons(sizes, activeSize, isAvailableFn, onClick) {
      var wrap = document.createElement("div");
      wrap.className = "kit-builder__sizes";
      if (sizes.length === 0) {
        var hint = document.createElement("span");
        hint.style.cssText = "font-size:12px;color:#888;";
        hint.textContent = "Selecione uma cor acima";
        wrap.appendChild(hint);
        return wrap;
      }
      sizes.forEach(function (size) {
        var available = isAvailableFn(size);
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "kit-builder__size" +
          (size === activeSize ? " is-active" : "") +
          (!available ? " kit-builder__size--unavailable" : "");
        btn.textContent = size;
        if (!available) btn.disabled = true;
        btn.addEventListener("click", function () { if (available) onClick(size); });
        wrap.appendChild(btn);
      });
      return wrap;
    }

    // ── Paid slide ────────────────────────────────────────────────────────────
    function buildQrSection(slotIndex) {
      // Clone the native block so the UI is pixel-perfect identical (styles, text, icon, pill)
      var clone = qrcodeRoot.cloneNode(true);
      clone.removeAttribute('id');
      clone.removeAttribute('data-qrcode-map');
      clone.removeAttribute('data-qrcode-initial-variant');
      clone.style.display = '';

      // Remove the hidden form input — kit builder posts via JS, not form submit
      var hiddenInput = clone.querySelector('[data-qrcode-value]');
      if (hiddenInput) hiddenInput.remove();

      // Wire the checkbox to per-slot state
      var cb = clone.querySelector('[data-qrcode-optin]');
      if (cb) {
        var meta = state.slotsMeta[slotIndex] || {};
        cb.checked = meta.qrHealth === "Sim";
        cb.addEventListener('change', function () {
          if (!state.slotsMeta[slotIndex]) state.slotsMeta[slotIndex] = {};
          state.slotsMeta[slotIndex].qrHealth = cb.checked ? "Sim" : "Não";
        });
      }

      return clone;
    }

    function buildPaidSlide(slotIndex) {
      var slides = totalSlides();
      var sel = state.slots[slotIndex] || {};
      var meta = state.slotsMeta[slotIndex] || { colorPicked: false, sizePicked: false };

      var slide = document.createElement("div");
      slide.className = "kit-builder__slide";

      // Step header
      var stepEl = document.createElement("div");
      stepEl.className = "kit-builder__slide-step";
      var em = document.createElement("em");
      em.textContent = "Passo " + (slotIndex + 1) + " de " + slides;
      stepEl.appendChild(em);
      stepEl.appendChild(document.createTextNode(": Escolha as opções para este item"));
      slide.appendChild(stepEl);

      var body = document.createElement("div");
      body.className = "kit-builder__slide-body";

      // ── Top row: thumbnail + pricing ──────────────────────────────────────────
      var topRow = document.createElement("div");
      topRow.className = "kit-builder__slide-top";

      var imgSrc = getImageForColor(kitVariants, shopifyVariants, sel.color || allColors[0] || "");
      if (imgSrc) {
        var img = document.createElement("img");
        img.className = "kit-builder__slide-image";
        img.src = imgSrc;
        img.alt = sel.color || "";
        img.width = 80; img.height = 80;
        topRow.appendChild(img);
      } else {
        var ph = document.createElement("div");
        ph.className = "kit-builder__slide-image-placeholder";
        topRow.appendChild(ph);
      }

      var priceWrap = document.createElement("div");
      priceWrap.className = "kit-builder__slide-pricing";
      var priceEl = document.createElement("span");
      priceEl.className = "kit-builder__slide-price";
      priceEl.textContent = money(state.tier.unit_price || 0) + "/un.";
      priceWrap.appendChild(priceEl);
      if (state.tier.discount_per_unit > 0) {
        var compareEl = document.createElement("span");
        compareEl.className = "kit-builder__slide-compare";
        compareEl.textContent = money((state.tier.unit_price || 0) + (state.tier.discount_per_unit || 0));
        priceWrap.appendChild(compareEl);
      }
      topRow.appendChild(priceWrap);
      body.appendChild(topRow);

      // ── Options: cor + tamanho (largura total) ────────────────────────────────
      var optsEl = document.createElement("div");
      optsEl.className = "kit-builder__slide-options";

      var selectedColor = null;
      if (allColors.length > 1) {
        var sortedColors = allColors.slice().sort(function (a, b) {
          var aOk = isColorAvailableForSlot(a, slotIndex) ? 0 : 1;
          var bOk = isColorAvailableForSlot(b, slotIndex) ? 0 : 1;
          return aOk - bOk;
        });
        optsEl.appendChild(buildOptionLabel("Cor:", meta.colorPicked ? sel.color : null));
        optsEl.appendChild(buildSwatches(sortedColors, meta.colorPicked ? sel.color : null, function (color) {
          var prevSize = sel.size || null;
          var keepSize = prevSize && isSizeAvailableForSlot(color, prevSize, slotIndex) ? prevSize : null;
          state.slots[slotIndex] = { color: color, size: keepSize };
          if (!state.slotsMeta[slotIndex]) state.slotsMeta[slotIndex] = {};
          state.slotsMeta[slotIndex].colorPicked = true;
          if (!keepSize) state.slotsMeta[slotIndex].sizePicked = false;
          var kv = kitVariants.find(function (v) { return v.color === color; });
          if (kv) updateProductGallery(kv.id, shopifyVariants, productSection);
          refreshSlide(slotIndex);
          refreshOtherSlides(slotIndex);
        }, function (color) {
          return isColorAvailableForSlot(color, slotIndex);
        }));
        selectedColor = meta.colorPicked ? sel.color : null;
      } else {
        if (!state.slotsMeta[slotIndex]) state.slotsMeta[slotIndex] = {};
        state.slotsMeta[slotIndex].colorPicked = true;
        if (!state.slots[slotIndex]) state.slots[slotIndex] = { color: allColors[0] || "", size: null };
        else if (!state.slots[slotIndex].color) state.slots[slotIndex].color = allColors[0] || "";
        selectedColor = allColors[0] || null;
      }

      if (allSizes.length > 0) {
        var sizesForColor = selectedColor
          ? unique(kitVariants.filter(function (v) { return v.color === selectedColor; }).map(function (v) { return v.size; }).filter(Boolean))
          : allSizes;

        optsEl.appendChild(buildOptionLabel("Tamanho:", meta.sizePicked ? sel.size : null));
        optsEl.appendChild(buildSizeButtons(
          sizesForColor,
          meta.sizePicked ? sel.size : null,
          function (size) {
            return isSizeAvailableForSlot(selectedColor || allColors[0], size, slotIndex);
          },
          function (size) {
            if (!state.slots[slotIndex]) state.slots[slotIndex] = { color: selectedColor || "", size: null };
            state.slots[slotIndex].size = size;
            if (!state.slotsMeta[slotIndex]) state.slotsMeta[slotIndex] = {};
            state.slotsMeta[slotIndex].sizePicked = true;
            refreshSlide(slotIndex);
            refreshOtherSlides(slotIndex);
          }
        ));
      } else {
        // Product has no size option — auto-mark as picked so slot completes
        if (!state.slotsMeta[slotIndex]) state.slotsMeta[slotIndex] = {};
        state.slotsMeta[slotIndex].sizePicked = true;
      }

      // QR Code de Saúde — show per-slot when the selected variant has QR enabled
      if (hasAnyQr && meta.colorPicked && meta.sizePicked) {
        var qrKv = kitVariants.find(function (v) {
          var cm = !sel.color || v.color === sel.color;
          var sm = !sel.size || v.size === sel.size;
          return cm && sm;
        });
        if (qrKv && qrcodeMap[String(qrKv.id)] === true) {
          optsEl.appendChild(buildQrSection(slotIndex));
        }
      }

      body.appendChild(optsEl);
      slide.appendChild(body);
      slide.appendChild(buildSlideActions(slotIndex));
      return slide;
    }

    // ── Gift slide ────────────────────────────────────────────────────────────
    function buildGiftSlide() {
      var slides = totalSlides();
      var giftSlideIndex = Number(state.tier.qty || 0);

      // Auto-pick color when only one (or zero) color options exist
      if (giftColors.length <= 1 && !state.gift.colorPicked) {
        state.gift.color = giftColors[0] || null;
        state.gift.colorPicked = true;
      }

      var selectedGiftColor = state.gift.colorPicked ? state.gift.color : null;

      // Sizes for selected color (or all if no color dimension)
      var allGiftSizes = unique(giftVariants.map(function (v) { return v.size; }).filter(Boolean));
      var giftHasSizes = allGiftSizes.length > 0;
      var giftSizes;
      if (giftColors.length === 0) {
        // No color option — show all sizes directly
        giftSizes = unique(giftVariants.map(function (v) { return v.size || v.title; }).filter(Boolean));
      } else if (selectedGiftColor) {
        giftSizes = unique(
          giftVariants.filter(function (v) { return v.color === selectedGiftColor; }).map(function (v) { return v.size; }).filter(Boolean)
        );
      } else {
        giftSizes = []; // waiting for color selection
      }

      var slide = document.createElement("div");
      slide.className = "kit-builder__slide kit-builder__slide--gift";

      // Step header
      var stepEl = document.createElement("div");
      stepEl.className = "kit-builder__slide-step";
      var em = document.createElement("em");
      em.textContent = "Passo " + slides + " de " + slides + ": Brinde!";
      stepEl.appendChild(em);
      stepEl.appendChild(document.createTextNode(" Escolha as opções da sua camisa grátis"));
      slide.appendChild(stepEl);

      var body = document.createElement("div");
      body.className = "kit-builder__slide-body";

      // ── Top row: thumbnail + "Grátis!" ────────────────────────────────────────
      var topRow = document.createElement("div");
      topRow.className = "kit-builder__slide-top";

      var imgColor = selectedGiftColor || giftColors[0] || null;
      var imgSrc = imgColor
        ? getImageForColor(giftVariants, giftShopifyVariants, imgColor)
        : getImageForColor(giftVariants, giftShopifyVariants, "");
      if (!imgSrc) imgSrc = getImageForColor(kitVariants, shopifyVariants, allColors[0] || "");

      if (imgSrc) {
        var img = document.createElement("img");
        img.className = "kit-builder__slide-image";
        img.src = imgSrc;
        img.alt = giftConfig.title || "Brinde";
        img.width = 80; img.height = 80;
        topRow.appendChild(img);
      } else {
        var ph = document.createElement("div");
        ph.className = "kit-builder__slide-image-placeholder";
        topRow.appendChild(ph);
      }

      var priceWrap = document.createElement("div");
      priceWrap.className = "kit-builder__slide-pricing";
      var nameEl = document.createElement("p");
      nameEl.className = "kit-builder__slide-name";
      nameEl.textContent = giftConfig.title || "Brinde grátis";
      priceWrap.appendChild(nameEl);
      var priceEl = document.createElement("span");
      priceEl.className = "kit-builder__slide-price kit-builder__slide-price--free";
      priceEl.textContent = "Grátis!";
      priceWrap.appendChild(priceEl);
      topRow.appendChild(priceWrap);
      body.appendChild(topRow);

      // ── Options: cor + tamanho (largura total) ────────────────────────────────
      var optsEl = document.createElement("div");
      optsEl.className = "kit-builder__slide-options";

      if (giftColors.length > 1) {
        optsEl.appendChild(buildOptionLabel("Cor:", state.gift.colorPicked ? state.gift.color : null));
        optsEl.appendChild(buildSwatches(giftColors, state.gift.colorPicked ? state.gift.color : null, function (color) {
          if (state.gift.color !== color) {
            state.gift.size = null;
            state.gift.sizePicked = false;
          }
          state.gift.color = color;
          state.gift.colorPicked = true;
          refreshSlide(giftSlideIndex);
        }));
      }

      if (giftHasSizes) {
        optsEl.appendChild(buildOptionLabel("Tamanho:", state.gift.sizePicked ? state.gift.size : null));
        optsEl.appendChild(buildSizeButtons(
          giftSizes,
          state.gift.sizePicked ? state.gift.size : null,
          function (size) {
            var gv = giftVariants.find(function (v) {
              return (selectedGiftColor ? v.color === selectedGiftColor : true) && (v.size === size || v.title === size);
            });
            return gv ? gv.available !== false : false;
          },
          function (size) {
            state.gift.size = size;
            state.gift.sizePicked = true;
            refreshSlide(giftSlideIndex);
          }
        ));
      } else {
        // Gift has no size option — auto-mark as picked once color is satisfied
        var giftColorSatisfied = giftColors.length <= 1 || state.gift.colorPicked;
        if (giftColorSatisfied) state.gift.sizePicked = true;
      }

      body.appendChild(optsEl);
      slide.appendChild(body);
      slide.appendChild(buildSlideActions(giftSlideIndex));
      return slide;
    }

    // ── Render ────────────────────────────────────────────────────────────────
    function renderCarousel() {
      slotsEl.innerHTML = "";
      if (!state.tier) return;

      var carousel = document.createElement("div");
      carousel.className = "kit-builder__carousel";

      var track = document.createElement("div");
      track.className = "kit-builder__track";
      track.style.transform = "translate3d(-" + (state.activeSlide * 100) + "%, 0, 0)";
      trackEl = track;

      var n = Number(state.tier.qty || 0);
      for (var i = 0; i < n; i++) track.appendChild(buildPaidSlide(i));
      if (state.tier.gift && giftConfig) track.appendChild(buildGiftSlide());

      carousel.appendChild(track);
      slotsEl.appendChild(carousel);
    }

    function renderTiers() {
      tiersEl.innerHTML = "";

      // "1 Peça" option — keeps native product form visible
      var isSingleActive = !state.tier;
      var singleBtn = document.createElement("button");
      singleBtn.type = "button";
      singleBtn.className = "kit-builder__tier" + (isSingleActive ? " is-active" : "");
      var sTitle = document.createElement("span");
      sTitle.className = "kit-builder__tier-title";
      sTitle.textContent = "1 unid.";
      var sPrice = document.createElement("span");
      sPrice.className = "kit-builder__tier-price";
      var basePrice = shopifyVariants.length ? (shopifyVariants[0].price || 0) : 0;
      sPrice.textContent = money(basePrice) + "/un.";
      singleBtn.append(sTitle, sPrice);
      singleBtn.addEventListener("click", function () {
        state.tier = null;
        state.activeSlide = 0;
        state.slots = [];
        state.slotsMeta = [];
        state.gift = { color: null, size: null, colorPicked: false, sizePicked: false };
        setActiveGift(null);
        setKitActive(false);
        render();
      });
      tiersEl.appendChild(singleBtn);

      tiers.forEach(function (tier) {
        var isActive = state.tier && state.tier.qty === tier.qty;
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "kit-builder__tier" + (isActive ? " is-active" : "");

        var titleEl = document.createElement("span");
        titleEl.className = "kit-builder__tier-title";
        titleEl.textContent = tier.label || "Kit " + tier.qty;

        var priceEl = document.createElement("span");
        priceEl.className = "kit-builder__tier-price";
        priceEl.textContent = money(tier.unit_price || 0) + "/un.";

        btn.append(titleEl, priceEl);

        if (tier.gift) {
          var badge = document.createElement("span");
          badge.className = "kit-builder__tier-badge";
          badge.textContent = tier.gift_badge || "+ brinde";
          btn.appendChild(badge);
        }

        btn.addEventListener("click", function () {
          state.tier = tier;
          state.activeSlide = 0;
          state.slots = [];
          state.slotsMeta = [];
          state.gift = { color: null, size: null, colorPicked: false, sizePicked: false };
          setActiveGift(tier.qty);
          setKitActive(true);
          render();
        });

        tiersEl.appendChild(btn);
      });
    }

    function render() {
      renderTiers();
      updateNativePrice();
      if (!state.tier) {
        slotsEl.innerHTML = "";
        return;
      }
      renderCarousel();
      setMessage("");
    }

    // ── Submit ────────────────────────────────────────────────────────────────
    function selectedItems() {
      var groupId = createId();
      var kitId = config.kit_id || "custom-kit";
      var tierQty = Number(state.tier.qty || 1);
      var items = [];

      // Build tier price/label maps so watchKitCart can update on downgrade
      var tierPricesMap = {};
      var tierLabelsMap = {};
      Object.keys(config.tiers || {}).forEach(function (k) {
        var t = config.tiers[k];
        var qty = String(t.qty || k);
        tierPricesMap[qty] = Number(t.unit_price || 0);
        tierLabelsMap[qty] = t.label || ("Kit " + qty);
      });
      var kitTierPrices = JSON.stringify(tierPricesMap);
      var kitTierLabels = JSON.stringify(tierLabelsMap);

      for (var i = 0; i < tierQty; i++) {
        var sel = state.slots[i] || {};
        if (!sel.color || !sel.size) {
          throw new Error("Peça " + (i + 1) + " está incompleta. Selecione cor e tamanho.");
        }
        var kv = kitVariants.find(function (v) { return v.color === sel.color && v.size === sel.size; });
        if (!kv || kv.available === false) {
          throw new Error("Combinação indisponível para a peça " + (i + 1) + ".");
        }
        var slotMeta = state.slotsMeta[i] || {};
        var itemProps = {
          "Promoção": state.tier.label || "Kit " + tierQty,
          "Peça": String(i + 1) + "/" + tierQty,
          _kit_group: groupId,
          _kit_id: kitId,
          _kit_tier: String(tierQty),
          _kit_slot: String(i + 1),
          _kit_unit_price: String(Number(state.tier.unit_price || 0)),
          _kit_tier_prices: kitTierPrices,
          _kit_tier_labels: kitTierLabels,
          _kit_tier_gifts: kitTierGifts,
        };
        if (hasAnyQr && qrcodeMap[String(kv.id)] === true) {
          itemProps["QR Code de Saúde"] = slotMeta.qrHealth || "Não";
        }
        items.push({ id: kv.id, quantity: 1, properties: itemProps });
      }

      if (state.tier.gift && giftConfig) {
        if (giftColors.length > 1 && !state.gift.colorPicked) {
          throw new Error("Selecione a cor do brinde.");
        }
        if (!state.gift.sizePicked) {
          throw new Error("Selecione o tamanho do brinde.");
        }
        var gv = giftVariants.find(function (v) {
          var colorMatch = giftColors.length > 1 ? v.color === state.gift.color : true;
          var sizeMatch = v.size === state.gift.size || v.title === state.gift.size;
          return colorMatch && sizeMatch;
        });
        if (!gv || gv.available === false) {
          throw new Error("Opção de brinde indisponível.");
        }
        items.push({
          id: gv.id,
          quantity: 1,
          properties: {
            "Promoção": state.tier.label || "Kit " + tierQty,
            "Peça": "Brinde",
            _kit_group: groupId,
            _kit_id: kitId,
            _kit_tier: String(tierQty),
            _kit_slot: "gift",
            _kit_gift: "true",
          },
        });
      }

      return items;
    }

    function submitKit() {
      setMessage("");
      var advanceBtn = slotsEl.querySelector(".kit-builder__advance");
      if (advanceBtn) { advanceBtn.disabled = true; advanceBtn.textContent = "Adicionando..."; }

      var items;
      try {
        items = selectedItems();
      } catch (error) {
        setMessage(error.message, true);
        if (advanceBtn) { advanceBtn.disabled = false; advanceBtn.textContent = "ADICIONAR AO CARRINHO"; }
        return;
      }

      fetch(theme.routes.cartAdd, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest", Accept: "application/json" },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status === 422) throw new Error(data.description || data.message || "Não foi possível adicionar o kit.");
            return data;
          });
        })
        .then(function () {
          // Rebuild cart drawer and open it
          document.dispatchEvent(new CustomEvent("cart:build"));
          document.dispatchEvent(new CustomEvent("cart:open"));
          if (advanceBtn) { advanceBtn.disabled = false; advanceBtn.textContent = "ADICIONAR AO CARRINHO"; }
        })
        .catch(function (error) {
          setMessage(error.message, true);
          if (advanceBtn) { advanceBtn.disabled = false; advanceBtn.textContent = "ADICIONAR AO CARRINHO"; }
        });
    }

    render();
  }

  function initAll() {
    document.querySelectorAll("[data-kit-builder]").forEach(initBuilder);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("quickview:loaded", initAll);
})();
